import _debounce from 'lodash/debounce'

const LOADING_TARGET = '.js-loading-target',
      SHOW_TARGET    = 'js-show-target',
      ANIMATION_TARGET = '.js-animation-target'

/**
 * Loading delaing after show Element
 * @export
 * @class Loading
 */
export default class Loading {

  constructor() {
    this.handler()
    this.showTarget      = document.getElementById(SHOW_TARGET)
    this.loadingTarget   = document.querySelectorAll(LOADING_TARGET)
    this.animationTarget = document.querySelectorAll(ANIMATION_TARGET)
  }

  handler() {
    if (document.getElementById(SHOW_TARGET) !== null) this.init()
  }

  init() {
    return new Promise((resolve) => {
      _debounce(() => {
        resolve(this.load())
      }, 400)()
    })
    .then(() => {
      this.show()
    })
    .then(() => {
      this.addClass()
    })
  }

  load() {
    $(LOADING_TARGET).find('img').one('load', () => {})
  }

  show() {
    this.showTarget.setAttribute('style', 'opacity: 1;')
  }

  addClass() {
    for (let i = 0; i < this.animationTarget.length; i++) {
      const className = this.animationTarget[i].getAttribute('data-animation')
      this.animationTarget[i].classList.add(className)
    }
  }

}